import { Button, DialogTitle } from '@mui/material'
import React from 'react'
import { tr } from "../../../../i18n";

function PreviewYoutube({url,onClose,onConfirm}) {
  return (
    <>
     <DialogTitle
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderBottom: "3px solid var(--primary-color)",
          fontSize: "18px",
          fontWeight: 700,
        }}
      >
        {tr("Youtube Preview")}
      </DialogTitle>
      <div
        style={{
          minHeight: "10dvh",
          width: "30dvw",
          display: "flex",
          justifyContent: "center",
          // border:'1px solid black'
        }}
      >
        <div
          style={{
            height: "100px",
            width: "100px",
           
          }}
        >
          <img
            src="/images/youtubeIcon.png"
            style={{ height: "100%", width: "100%" }}
          />
        </div>
      </div>

      <div
        style={{
          maxHeight: "30dvh",
          width: "30dvw",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 10,
          gap: 10,
          
        }}
      >
      <iframe height={'300px'} width={'300px'} src={`https://www.youtube.com/embed/${url.split("=")[1]}?rel=0&amp;autoplay=1&mute={{muteVal}}`}/>
      </div>
      <div
      style={{
        maxHeight: "10dvh",
        width: "30dvw",
        display: "flex",
        justifyContent:'center',
        padding: 10,
        gap: 10,
        
      }}
      >
        <Button onClick={onConfirm} variant={'contained'} style={{background:'var(--primary-color)'}} title={tr("Preview")}>{tr("Confirm")}</Button>
        <Button onClick={onClose}  variant={'contained'} style={{background:'var(--primary-color)'}} title={tr("Submit")}>{tr("Cancel")}</Button>
      </div>
    </>
  )
}

export default PreviewYoutube
